import {
  LoadWidgetResult,
  loadWidgetThunkAction,
} from '../../redux/load-widget-thunk';
import { RootState } from '../../redux/root-reducer';
import { fetchEventDetails } from '../event-details/event-details-thunk';
import { setActiveStep } from '../manage-steps/manage-steps-reducer';
import { StepTypes } from '../manage-steps/manage-steps-types';
import {
  checkout,
  CompletePurchasePayload,
} from '../purchase-tickets/purchase-actions';

const REGISTRATIONS_EVENTS = {
  EVENT_LOADED: 'reg-wdgt__event-loaded',
  EVENT_REGISTRATION_STARTED: 'Event Registration Started',
  EVENT_REG_WIDGET_SUCCESS: 'Event Registration Widget Successful',
  EVENT_STEP: 'Event Registration Step',
  EVENT_SIGN_UP: 'Event Registration Sign Up Clicked',
  EVENT_SIGN_IN: 'Event Registration Sign In Clicked',
  EVENT_SIGN_OUT: 'Event Registration Sign Out Clicked',
};

/** @type {ActionTransforms} */
const actionTransforms: Record<string, TransformFn> = {
  [loadWidgetThunkAction.fulfilled.type]: (
    payload: LoadWidgetResult,
    state: RootState,
  ) => ({
    name: REGISTRATIONS_EVENTS.EVENT_REGISTRATION_STARTED,
    properties: {
      event_slug: payload.eventDetails.event.url,
      event_id: payload.eventDetails.event.externalId,
      method: payload.widgetSource,
      sign_in: state?.authentication?.token !== null,
    },
  }),
  [checkout.fulfilled.type]: (
    _payload: CompletePurchasePayload,
    state: RootState,
  ) => ({
    name: REGISTRATIONS_EVENTS.EVENT_REG_WIDGET_SUCCESS,
    properties: {
      event_slug: state.eventDetails.event.url,
      method: state.eventDetails.widgetSource,
      event_id: state.eventDetails.event.externalId,
    },
  }),
  [fetchEventDetails.fulfilled.type]: (payload: { eventSlug: string }) => ({
    name: REGISTRATIONS_EVENTS.EVENT_LOADED,
    properties: {
      event_slug: payload.eventSlug,
    },
  }),
  [setActiveStep.type]: (payload: StepTypes, state: RootState) => ({
    name: `${REGISTRATIONS_EVENTS.EVENT_STEP}: ${payload}`,
    properties: {
      step: payload,
      isLoggedIn: Boolean(
        state.authentication.token && state.authentication.user,
      ),
    },
  }),
};

export { REGISTRATIONS_EVENTS, actionTransforms };
